// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  //************************************ debut local**************************************************//
  // urlServer1: 'http://localhost/SiteCmsServeur/',
  // urlServerphoto: 'http://localhost/SiteCmsServeur/FileIEC/',

  //IEC
  //  urllogoIec: "http://localhost/SiteCmsServeur/FileIEC/upload/img/upload_iec",
  //  urlInfoIec: "http://localhost/SiteCmsServeur/FileIEC/upload/img/information_iec",
  //  urlfileIec: "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec",
  //  urlVideoIec: "http://localhost/SiteCmsServeur/FileIEC/upload/video/iec", 


  // //Entrepot med livrer
  // urlfileEntrepotMedLivrer : "http://localhost/SiteCmsServeur/FileIEC/upload/file/entrepot/med_livrer",
  //  //Entrepot med perimer
  // urlfileEntrepotMedPerimer : "http://localhost/SiteCmsServeur/FileIEC/upload/file/entrepot/perimer",
  // //Biblio Virtuel
  // urlfileBiblioteque : "http://localhost/SiteCmsServeur/FileIEC/upload/file/bibliotheque",
  //  //text_lois
  //  urlfileText_Lois : "http://localhost/SiteCmsServeur/FileIEC/upload/file/text_lois",

  //************************************ fin  local**************************************************//


  //************************************ debut of line**************************************************//
  //php serveur
  urlServer1: 'http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/index.php/',
  urlServerphoto: 'http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/',

  //ws nathon portail net
  //urlServer: 'http://sysinfo.mef.gov.mg:9727/cms/',

  //ws nathon portail local 
  urlServer: 'http://10.2.250.167:7001/cms/',


  //crud rdv  nathon
  urlServer3: 'http://sysinfo.mef.gov.mg:9727/cms/',

  //IEC
  urllogoIec: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/img/upload_iec",
  urlInfoIec: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/img/information_iec",
  urlfileIec: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/iec",
  urlVideoIec: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/video/iec",

  //Entrepot med livrer
  urlfileEntrepotMedLivrer: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIE/upload/file/entrepot/med_livrer",
  //Entrepot med perimer
  urlfileEntrepotMedPerimer: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/entrepot/perimer",
  //Biblio Virtuel
  urlfileBiblioteque: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/bibliotheque",
  //text_lois
  urlfileText_Lois: "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/text_lois",

  //************************************ fin  of line**************************************************//

};



//45000 + 16000 + 70000 + 35000 + 5000